import { render, staticRenderFns } from "./SideBarDrawer.vue?vue&type=template&id=d9141b14&scoped=true"
import script from "./SideBarDrawer.vue?vue&type=script&lang=ts"
export * from "./SideBarDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9141b14",
  null
  
)

export default component.exports